import { animate, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AppInjector } from 'src/app/app.module';
import { BaseComponent } from 'src/app/_core/base/base.component';
import { TimeTableDetailService } from './time-table-detail.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-time-table-detail',
  templateUrl: './time-table-detail.component.html',
  styleUrls: ['./time-table-detail.component.scss'],
  animations: [
    trigger('toggleBox', [
      transition('open => closed', [
        animate('.3s')
      ]),
      transition('closed => open', [
        animate('0.3s')
      ]),
    ])
  ]
})
export class TimeTableDetailComponent extends BaseComponent implements OnInit {

  titlePage: any = 'Thời khóa biểu';
  timeTableService: TimeTableDetailService;
  isOpen: any = true;
  listYear: any;
  isInValid: any = true;
  itemPerPage: any = 10000;
  dateRange: Date[] = [];

  pageSizesExport: any = [
    { name: '3', value: 3 },
    { name: '6', value: 9 },
    { name: 'Tất cả', value: 10000 },
  ];
  columnTitle = [
    { name: 'Lớp', width: 30 },
    { name: 'Ca học', width: 5 },
    { name: 'Thứ 2', width: 100, value: 2, date: null },
    { name: 'Thứ 3', width: 100, value: 3, date: null },
    { name: 'Thứ 4', width: 100, value: 4, date: null },
    { name: 'Thứ 5', width: 100, value: 5, date: null },
    { name: 'Thứ 6', width: 100, value: 6, date: null },
    { name: 'Thứ bảy', width: 100, value: 7, date: null },
    { name: 'Chủ nhật', width: 100, value: 8, date: null },
  ];

  columnDay = ['2', '3', '4', '5', '6', '7', 'CN'];
  columnHour = [
    { name: 'Sáng', value: 0 },
    { name: 'Chiều', value: 1 },
    { name: 'Tối', value: 2 },
  ];

  listGeneration: any;
  listDepartment: any;
  listSchoolYear: any;
  listMajor: any;
  listClass: any;
  listWeek: any;
  listTimeTable: any;
  dataWeekNow: any;

  filter = new FormGroup({
    ID_he: new FormControl(0),
    ID_khoa: new FormControl(0),
    Khoa_hoc: new FormControl(0),
    ID_lop: new FormControl(0),
    ID_kh_tuan: new FormControl(0),
    ID_kh: new FormControl(0)
  });

  resetForm() {
    this.filter.patchValue({
      ID_he: 0,
      ID_khoa: 0,
      Khoa_hoc: 0,
      ID_lop: 0,
    });
  }

  constructor() {
    super();
    this.timeTableService = AppInjector.get(TimeTableDetailService);
  }

  breadCrumbs = [
    {
      name: 'Đăng nhập vào hệ thống',
      routerLink: '../../login',
      active: true,
      icon: 'fas fa-home',
    },
    {
      name: 'Chi tiết thời khóa biểu',
      routerLink: '',
      active: false,
      icon: ''
    },
  ];


  async ngOnInit(): Promise<void> {
    await this.getGeneration();
    await this.getDepartment();
    await this.getSchoolYear();
    await this.getClass();
    await this.getScheduleTime();
  }

  toggle() {
    this.isOpen = !this.isOpen;
  }

  getRequestForm() {
    let req = {};
    req = {
      ID_kh_tuan: this.filter.value.ID_kh_tuan,
      ID_he: this.filter.value.ID_he,
      ID_khoa: this.filter.value.ID_khoa,
      ID_lop: this.filter.value.ID_lop,
      Khoa_hoc: this.filter.value.Khoa_hoc,
      ID_kh: this.filter.value.ID_kh
    }
    return req;
  }

  getGeneration = async () => {
    return await this.timeTableService.getGeneration().subscribe(
      (res: any) => {
        this.listGeneration = res;
      }
    );
  }

  getDepartment = async () => {
    return await this.timeTableService.getDepartment().subscribe(
      (res: any) => {
        this.listDepartment = res;
      }
    );
  }

  getSchoolYear = async () => {
    return await this.timeTableService.getSchoolYear().subscribe(
      (res: any) => {
        this.listSchoolYear = res.Data.map(x => x.Khoa_hoc);
        if (this.listSchoolYear.length > 0) {
          this.listSchoolYear = _.uniq(this.listSchoolYear);
        }
      }
    );
  }

  getClass = async () => {
    return await this.timeTableService.getClass().subscribe(
      (res: any) => {
        this.listClass = res;
      }
    );
  }

  _id_KH: any;
  _id_KHTuan: any;
  messageError: any;
  getScheduleTime = async () => {
    await this.timeTableService.getYear().subscribe(
      async (res: any) => {
        if (res.Status != 1) {
          this.isInValid = true;
          this.messageError = res.Message;
        }
        else {
          this.isInValid = false;
          this.listYear = res.KeHoachNams;
          if (this.listYear.length > 0) {
            //let _idKH = _.last(this.listYear).ID_kh;
            // let req = {
            //   RequestID: _idKH
            // }
            this.timeTableService.getScheduleNow().subscribe(
              (res: any) => {
                this._id_KH = res.ID_kh;
                this._id_KHTuan = res.ID_kh_tuan;
                let req = {
                  RequestID: this._id_KH,
                  IDKeHoachTuan: this._id_KHTuan
                }
                this.getWeek(req);
              }
            );
          }
        }
      }
    );
  }

  patchValueListDay() {
    this.dateRange = [];
    let rangeDayOfWeek = _.filter(this.listWeek, ['ID_kh_tuan', this.filter.value.ID_kh_tuan])[0];
    if (rangeDayOfWeek) {
      let currentDate = new Date(rangeDayOfWeek.Tu_ngay);
      let maxDate = new Date(rangeDayOfWeek.Den_ngay);
      while (currentDate <= maxDate) {
        this.dateRange.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
      }
      this.pathvalueDate(this.dateRange);
    };
  }

  getWeek = async (req: any) => {
    await this.timeTableService.getWeek(req).subscribe(
      async (res: any) => {
        this.listWeek = res.KeHoachTuans;
        if (this.listWeek.length > 0) {
          this.filter.patchValue({
            //ID_kh_tuan: _.first(this.listWeek).ID_kh_tuan,
            ID_kh_tuan: req.IDKeHoachTuan,
            ID_kh: req.RequestID,
          });
          this.patchValueListDay();
          await this.getTimeTable();
        }
      }
    );
  }

  pathvalueDate(dates: any) {
    for (let i = 2; i <= 8; i++) {
      this.columnTitle.filter(x => x.value == i)[0].date = dates[i - 2];
    }
  }

  getTimeTable = async () => {
    this.spinner.show();
    return await this.timeTableService.getTimeTable(this.getRequestForm()).subscribe(
      (res: any) => {
        res.Data.forEach(lop => {
          lop.LichLop.forEach(lich => {
            lich.LichNgay.forEach(ca => {
              ca.LichCa.sort((a, b) => {
                // Chỉ lấy tiết bắt đầu từ trường Tiet
                const startA = parseInt(a.Tiet.split('-')[0], 10);
                const startB = parseInt(b.Tiet.split('-')[0], 10);
                return startA - startB;
              });
            });
          });
        });
  
        // Không cần biến `data` nữa, chỉ cần gán `res.Data` cho `listTimeTable`
        this.listTimeTable = res.Data;
        console.log(this.listTimeTable);
        this.spinner.hide();
      },
      (error) => {
        console.error(error);
        this.spinner.hide();
      }
    );
  };
  

  filterBySelectByYear() {
    if (this.filter.value.ID_kh > 0) {
      this.listWeek = _.filter(this.listWeek, ['ID_kh', this.filter.value.ID_kh]);
    }
    let req = {
      RequestID: this.filter.value.ID_kh
    }
    this.getWeek(req);
  }

  filterBySelect() {
    this.spinner.show();
    this.timeTableService.getClass().subscribe(
      (res: any) => {
        this.listClass = res;
        if (this.listClass.length > 0) {
          if (this.filter.value.ID_he) {
            this.listClass = _.filter(this.listClass, ['ID_he', this.filter.value.ID_he]);
          }
          if (this.filter.value.ID_khoa > 0) {
            this.listClass = _.filter(this.listClass, ['ID_khoa', this.filter.value.ID_khoa]);
          }
          if (this.filter.value.Khoa_hoc > 0) {
            this.listClass = _.filter(this.listClass, ['Khoa_hoc', this.filter.value.Khoa_hoc]);
          }
        }
        this.spinner.hide();
      }
    );
  }

  printData() {
    window.print();
  }

  search = async () => {
    if (!(this.filter.value.ID_kh_tuan > 0)) {
      this.toastr.warning('Vui lòng chọn tuần cần tra cứu TKB');
    }
    else {
      await this.getTimeTable();
      this.patchValueListDay();
    }
  }

  async changePage() {
    this.itemPerPage = this.itemPerPage == 'Tất cả' ? 10000000 : this.itemPerPage;
  }

  exportToExcel() {
    var r = confirm("File của bạn sẽ được tải xuống trong giây lát!");
    if (r) {
      this.spinner.show();
      this.timeTableService.exportExcel(this.getRequestForm())
        .subscribe(z => {
          if (z.Status == 1) {
            this.exportService.exportExcelByte(z.FileData, 'ThongKe');
            this.toastr.success("File đã được tải xuống", "Tác vụ thành công")
            this.spinner.hide();
          }
          else {
            this.toastr.error(z.Message, "Tác vụ thất bại")
            this.spinner.hide();
          }
        });
    };
  }
}
